import { createContext } from 'react';

const PhoneMenuContext = createContext();
PhoneMenuContext.displayName = 'PhoneMenuContext';

export default PhoneMenuContext;
